import React, { useState, useEffect } from 'react';
// import styles from "./Input.scss";
import { IPropertyWizardInput } from './NewPropertyWizard';
import styles from './NewPropertyWizard.scss';
import NumberField from '../MaterialUi/NumberField';
import { IEditProperty } from './EditProperty';

export type IInputProps = IPropertyWizardInput

const Input: React.FC<React.PropsWithChildren<IInputProps>> = ({ data = null, step = null, onChange = () => { } }) => {
    const [nextData, setNextData] = useState(data); // for showing internal state without rerendering complete parent component

    useEffect(() => {
        setNextData(data);
    }, [data]);

    const value = typeof nextData[step.name] === 'string' ? parseFloat(nextData[step.name]) || '' : nextData[step.name] || '';

    const [validHint, setValidHint] = useState<string>('');

    const handleChange = (name: keyof IEditProperty, value: number) => {
        setNextData({ ...nextData, [name]: value });
        onChange(name, value);
        if (validHint && step?.isValid(value)) {
            setValidHint('');
        }
    };

    const handleBlur = () => {
        if (value && step.isValid && step.validHint && !step.isValid(value)) {
            setValidHint(step.validHint);
        } else {
            setValidHint('');
        }
    };

    return (
        <div className={styles.input}>
            {/* <input
                autoFocus
                // key={step?.name}
                name={step.name}
                value={value}
                type="number"
                onChange={(ev) => {
                    setValue(ev.target.value);
                }}
            /> */}
            {/* <div className="input-field">
                <label htmlFor={step.name}>{step.label}</label> */}
            <NumberField
                label={step.label}
                key={step.name}
                onChange={handleChange}
                // onValueChange={(value) => {
                //     onChange(step.name, value.value);
                // }}
                allowEmptyFormatting={true}
                name={step.name}
                value={value}
                // displayType={'input'}
                thousandSeparator={step.name === 'baujahr' || step.name === 'property_id' ? null : '.'}
                decimalSeparator={','}
                // onValueChange={handlePercetageChange}
                disabled={false}
                suffix={step.unit ? ` ${step.unit}` : ''}
                autoFocus={location.hash.indexOf('step') > 0}
                error={validHint !== ''}
                helperText={validHint}
                onBlur={handleBlur}
                fixedDecimalScale={step.unit === '€' && value && parseInt(value as string) !== parseFloat(value as string)}
                decimalScale={step.decimalScale ? step.decimalScale : step.unit === '€' ? 2 : 0}
            />
            {/* </div> */}
        </div>
    );
};

export default Input;
